export const headSort = [
  { text: "Id", field: "id", model: null },
  { text: "Nombre", field: "first_name", model: null },
  { text: "Apellido", field: "last_name", model: null },
  { text: "Email", field: "email", model: null },
  { text: "Rol", field: "profile_id", model: null },
  { text: "Activo", field: "active", model: null },
  { text: "", field: null, model: null },
];
